/* tslint:disable */
/* eslint-disable */
/**
 * RZPV API
 * API rozklikávacího rozpočtu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { EnumPlanObdobi } from '../model';
// @ts-ignore
import { FulltextResult } from '../model';
/**
 * FulltextControllerApi - axios parameter creator
 * @export
 */
export const FulltextControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fulltext 
         * @param {number} idPlanVerze 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByFulltext: async (fulltext: string, idPlanVerze: number, planObdobi: EnumPlanObdobi, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fulltext' is not null or undefined
            assertParamExists('searchByFulltext', 'fulltext', fulltext)
            // verify required parameter 'idPlanVerze' is not null or undefined
            assertParamExists('searchByFulltext', 'idPlanVerze', idPlanVerze)
            // verify required parameter 'planObdobi' is not null or undefined
            assertParamExists('searchByFulltext', 'planObdobi', planObdobi)
            const localVarPath = `/api/rzpv/fulltext`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fulltext !== undefined) {
                localVarQueryParameter['fulltext'] = fulltext;
            }

            if (idPlanVerze !== undefined) {
                localVarQueryParameter['idPlanVerze'] = idPlanVerze;
            }

            if (planObdobi !== undefined) {
                localVarQueryParameter['planObdobi'] = planObdobi;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FulltextControllerApi - functional programming interface
 * @export
 */
export const FulltextControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FulltextControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} fulltext 
         * @param {number} idPlanVerze 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchByFulltext(fulltext: string, idPlanVerze: number, planObdobi: EnumPlanObdobi, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FulltextResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchByFulltext(fulltext, idPlanVerze, planObdobi, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FulltextControllerApi - factory interface
 * @export
 */
export const FulltextControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FulltextControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} fulltext 
         * @param {number} idPlanVerze 
         * @param {EnumPlanObdobi} planObdobi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByFulltext(fulltext: string, idPlanVerze: number, planObdobi: EnumPlanObdobi, options?: any): AxiosPromise<Array<FulltextResult>> {
            return localVarFp.searchByFulltext(fulltext, idPlanVerze, planObdobi, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FulltextControllerApi - interface
 * @export
 * @interface FulltextControllerApi
 */
export interface FulltextControllerApiInterface {
    /**
     * 
     * @param {string} fulltext 
     * @param {number} idPlanVerze 
     * @param {EnumPlanObdobi} planObdobi 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FulltextControllerApiInterface
     */
    searchByFulltext(fulltext: string, idPlanVerze: number, planObdobi: EnumPlanObdobi, options?: any): AxiosPromise<Array<FulltextResult>>;

}

/**
 * FulltextControllerApi - object-oriented interface
 * @export
 * @class FulltextControllerApi
 * @extends {BaseAPI}
 */
export class FulltextControllerApi extends BaseAPI implements FulltextControllerApiInterface {
    /**
     * 
     * @param {string} fulltext 
     * @param {number} idPlanVerze 
     * @param {EnumPlanObdobi} planObdobi 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FulltextControllerApi
     */
    public searchByFulltext(fulltext: string, idPlanVerze: number, planObdobi: EnumPlanObdobi, options?: any) {
        return FulltextControllerApiFp(this.configuration).searchByFulltext(fulltext, idPlanVerze, planObdobi, options).then((request) => request(this.axios, this.basePath));
    }
}
